import ColorAttributeValueEditor from '../views/pairing/editor/ColorAttributeValueEditor';
import ColorAttributeValueValidator from '../views/pairing/editor/ColorAttributeValidator';
export default {
  install(molten) {
    molten.addPlugin('AttributeValueEditor', ColorAttributeValueEditor);
    molten.addPlugin('AttributeValueValidator', {
      name: 'vehicle.color',
      objectType: 'vehicle',
      valueValidator: ColorAttributeValueValidator
    });
  }
};